import { ApiResult, HttpClient } from "../http.js";
import type {
  CustomerScoreDto,
  CustomerScoreListDto,
  SetCustomerScoreFactorPayload,
} from "../types/customer-scores.js";

/**
 * Customer score ("Kunde-score"), computed server-side. Hit rate, DB% and netto are commercial
 * data, so every route needs `quotes.viewAll`; changing a factor level also needs `customers.edit`.
 * The company settings live on `SettingsApi` (`getCustomerScore` / `updateCustomerScore`).
 */
export class CustomerScoresApi {
  constructor(private readonly http: HttpClient) {}

  /** GET /api/customers/{id}/score — the full breakdown behind one customer's score. */
  getScore(customerId: string): Promise<ApiResult<CustomerScoreDto>> {
    return this.http.get<CustomerScoreDto>(`/api/customers/${customerId}/score`);
  }

  /** PUT /api/customers/{id}/score-factors — pick a level for one factor; returns the recomputed score. */
  setFactor(customerId: string, payload: SetCustomerScoreFactorPayload): Promise<ApiResult<CustomerScoreDto>> {
    return this.http.put<CustomerScoreDto>(`/api/customers/${customerId}/score-factors`, { body: payload });
  }

  /**
   * GET /api/customer-scores?ids=a,b,c — one row per customer. With `ids` (at most 200) exactly those
   * customers; without, every customer that has at least one decided quote (the report).
   */
  list(ids?: string[]): Promise<ApiResult<CustomerScoreListDto>> {
    return this.http.get<CustomerScoreListDto>("/api/customer-scores", {
      query: ids && ids.length > 0 ? { ids: ids.join(",") } : {},
    });
  }
}
